import { useEffect, useState } from "react";
import NewTrainerItem from "../../../../components/trainer/components/NewTrainerItem";
import { setFavoriteTrainer } from "../../../../services/favoriteService";
import { Paginator } from "primereact/paginator";
import { getCurrentUserFromLocalStorage, getI18nLanguageFromLocalStorage } from "../../../../helpers/localStorageHelper";
import { COUPON_TARGETS } from "../../../../constants/coupon-targets";
export default function NewTrainerList({
  source,
  props,
  bundleDiscounts,
  notFoundImage,
  onPaging,
  messages,
  directDeliveryCoupons
}) {
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);
  const [dataSources, setDataSources] = useState([]);
  const [activeTooltipId, setActiveTooltipId] = useState(null);

  const [lang, setLanguage] = useState([]);
  const currentUser = getCurrentUserFromLocalStorage();

  useEffect(() => {
    const language = getI18nLanguageFromLocalStorage();
    setLanguage(language);
  }, [lang]);

  const paginatorTemplate = {
    layout: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
    FirstPageLink: (options) => {
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <i className="pi pi-angle-double-left"></i>
        </button>
      );
    },
    PrevPageLink: (options) => {
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <i className="pi pi-angle-left"></i>
        </button>
      );
    },
    PageLinks: (options) => {
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
        >
          {options.page + 1}
        </button>
      );
    },
    NextPageLink: (options) => {
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <i className="pi pi-angle-right"></i>
        </button>
      );
    },
    LastPageLink: (options) => {
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <i className="pi pi-angle-double-right"></i>
        </button>
      );
    },
  };

  useEffect(() => {
    if (source?.pagingInfo?.totalRecordCount) {
      setTotalRecords(source.pagingInfo.totalRecordCount);
    }
    if (source?.data) {
      setDataSources(source.data);
    }
  }, [source]);

  const handlePaging = (event) => {
    setFirst(event.first);
    const request = {
      first: event.first,
      rows: rows,
      filters: null,
    };

    onPaging(request);

    const element = document.getElementById("trainer-list-item");
    if (element) {
      const remInPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const y = element.getBoundingClientRect().top + window.pageYOffset - (8.6 * remInPx);
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  const handleFavoriteTrainer = async (publicId) => {
    setFavoriteTrainer(publicId).then((response) => {
      if (response.status === 200) {
        const trainerIndex = dataSources.findIndex(
          (trainer) => trainer.publicId === publicId
        );
        if (trainerIndex !== -1) {
          const updatedTrainer = {
            ...dataSources[trainerIndex],
            isFavorite: !dataSources[trainerIndex].isFavorite,
          };
          const updatedTrainerList = [...dataSources];
          updatedTrainerList[trainerIndex] = updatedTrainer;
          setDataSources(updatedTrainerList);
        }
      }
    });
  };

  return (
    <>
      {dataSources.length === 0 && (
        <div className="flex flex-column gap-5">
          <div className="flex flex-row justify-content-center align-items-center p-lecture-not-found flex-wrap md:flex-nowrap">
            <div>
              <img alt="not_found_1" src={props.lectureListNotFoundPicture1} />
            </div>
            <div className="flex flex-column ml-3">
              <div className="w-full flex justify-content-center keduall-typography heading-h2-bold-700">
                {props.lectureListNotFoundContent1}
              </div>
              <div className="w-full flex justify-content-center keduall-typography heading-h2-bold-700">
                {props.lectureListNotFoundContent2}
              </div>
            </div>
            <div>
              <img alt="not_found_2" src={props.lectureListNotFoundPicture2} />
            </div>
          </div>
        </div>
      )}
      {dataSources.length > 0 && (
        <>
          <div id="trainer-list-item" className="flex flex-column gap-5 w-full">
            {dataSources.map((trainer) => {
              return (
                <NewTrainerItem
                  props={props.trainerItemProps}
                  key={trainer.id}
                  source={trainer}
                  bundleDiscounts={bundleDiscounts}
                  activeTooltipId={activeTooltipId}
                  onItemHover={(trainerId) => setActiveTooltipId(trainerId)}
                  onViewMoreClick={() => {
                    window.location.href = `${window.location.pathname}/${trainer.publicId}`;
                  }}
                  onFavoriteClick={() => {
                    handleFavoriteTrainer(trainer.publicId);
                  }}
                  lang={lang}
                  currentUser={currentUser}
                  messages={messages}
                  isActiveDirectDeliveryCoupons={directDeliveryCoupons.some(coupon => coupon.targetContentType === COUPON_TARGETS.TRAINER && (coupon.applyFor.length === 0 || coupon.applyFor.some(apply => apply === trainer.publicId)))}
                />
              );
            })}
          </div>
          {totalRecords > rows && (
            <Paginator
              template={paginatorTemplate}
              first={first}
              rows={rows}
              totalRecords={totalRecords}
              onPageChange={handlePaging}
              className="keduall-paginator"
            />
          )}
        </>
      )}
    </>
  );
}
